/* cart-recommendations.js — "Others also bought" rows in the native drawer.

   2026-09-02 (Ondrej: no Rebuy, no third-party dependency, no commissions):
   picks come from Shopify's native recommendations, complementary intent
   first (our own co-purchase engine fills that list), `related` as the
   fallback. Rows are rendered by Liquid (sections/ci-drawer-rec.liquid) so
   prices are market-correct. Products already in the cart are excluded, and
   the pick window rotates on EVERY cart change (qty included) over a pool
   cached per lead product. The server-rendered list (data-url) is the last
   resort when the JSON endpoint is unreachable. */
/* The asset is included by both theme.liquid and the header group, so a
   bare top-level class declaration threw "already been declared" on the
   second load. Guarded and scoped. */
(function () {
  if (window.customElements && customElements.get('cart-recommendations')) return;


  /* 2026-09-02: variant chooser on multi-variant recommendation rows. The row's ADD button posts
     data-variant-id; keep it and the price in sync with the <select>. Delegated so it survives re-renders. */
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.classList || !sel.classList.contains('ci-rec-variant')) return;
    var li = sel.closest('li'); if (!li) return;
    var add = li.querySelector('.ci-rec-add'); var opt = sel.options[sel.selectedIndex];
    if (!add || !opt) return;
    add.setAttribute('data-variant-id', opt.value);
    try { window.__ciTrack && window.__ciTrack('ci_rec_variant_change', { ci_candidate: li.getAttribute('data-rec-candidate') || '', ci_variant: opt.value, ci_option: opt.textContent.trim() }); } catch (te) {}
    var sale = li.querySelector('.ci-rec-price__sale'); var was = li.querySelector('.ci-rec-price__was');
    var pt = opt.getAttribute('data-price-text'), ct = opt.getAttribute('data-compare-text');
    if (sale && pt) sale.textContent = pt;
    if (ct) {
      if (!was) { was = document.createElement('s'); was.className = 'ci-rec-price__was'; sale && sale.insertAdjacentElement('afterend', was); }
      was.textContent = ct; sale && sale.classList.remove('ci-rec-price__sale--plain');
    } else if (was) { was.remove(); sale && sale.classList.add('ci-rec-price__sale--plain'); }
  });
class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var fp = this.dataset.fp || '';
    var cache = window.__ciRecsCache;
    if (cache && cache.fp === fp && cache.html) {
      this.setList(cache.html);
      return;
    }
    /* The drawer renders twice per change (optimistic paint, then the real
       render); share one in-flight fill per fingerprint so rows are fetched
       once. */
    var self = this;
    var inflight = window.__ciRecsInflight;
    if (inflight && inflight.fp === fp && inflight.promise) {
      /* 2026-10-12: a promise that resolved to '' (its element was replaced mid-load) falls back to the cached rows of this fingerprint */
      inflight.promise.then(function (html) {
        var c = window.__ciRecsCache;
        if (!html && c && c.fp === fp && c.html) html = c.html;
        if (html && self.isConnected) self.setList(html);
      });
      return;
    }
    var promise = this.loadNative().then(function (ok) { if (!ok) self.loadShopify(0); return (window.__ciRecsCache && window.__ciRecsCache.fp === fp) ? window.__ciRecsCache.html : ''; })
      .catch(function () { self.loadShopify(0); return ''; });
    window.__ciRecsInflight = { fp: fp, promise: promise };
  }

  setList(html) {
    var ul = this.querySelector('.mini-cart__navigation');
    if (!ul) return;
    ul.innerHTML = html;
    window.__ciRecsCache = { fp: this.dataset.fp || '', html: html };
    /* impressions: one per cart state + candidate */
    try {
      var T = window.__ciTrack, fp = this.dataset.fp || '';
      var seen = window.__ciRecSeen || (window.__ciRecSeen = {});
      Array.prototype.forEach.call(ul.querySelectorAll('li'), function (li, pos) {
        li.setAttribute('data-rec-pos', String(pos));
        var key = fp + '|' + (li.getAttribute('data-rec-candidate') || pos);
        if (seen[key] || !T) return;
        seen[key] = 1;
        T('ci_rec_impression', { ci_surface: 'drawer', ci_host: li.getAttribute('data-rec-host') || '', ci_candidate: li.getAttribute('data-rec-candidate') || '',
          ci_rank: li.getAttribute('data-rec-rank') || '', ci_pos: pos, ci_intent: li.getAttribute('data-rec-intent') || '', ci_chooser: li.querySelector('.ci-rec-variant') ? 1 : 0 });
      });
    } catch (e) {}
    /* 2026-10-13 gift arm: lets the "Unlocks free gift" tags refresh (assets/ci-native-cart.js) */
    try { document.dispatchEvent(new CustomEvent('ci:recs:set')); } catch (e) {}
  }

  loadNative() {
    /* 2026-09-02 (Ondrej: no Rebuy, no third-party dependency). Shopify's
       native recommendations for the most recently added product, COMPLEMENTARY
       intent first (fed by our own co-purchase engine through the
       complementary-products metafield), `related` when a product has no
       complements yet. In-cart products excluded; the pick window rotates on
       every cart change over a pool cached per lead product. */
    var self = this;
    var limit = parseInt(this.dataset.limit, 10) || 3;
    var ids = (this.dataset.ids || '').split(',').filter(Boolean);
    var lead = ids[0];
    if (!lead) return Promise.resolve(false);
    var inCart = {};
    (this.dataset.inCart || '').split(',').filter(Boolean).forEach(function (h) { inCart[h] = 1; });
    var fp = this.dataset.fp || '';
    /* Rotation (restored 2026-09-07 03:55Z, Ondrej: keep the rotation, results are
       good; a session-stable seed ran 02:00-03:55Z only). A page-level counter
       advances the window into the cached pool on every cart-fingerprint change
       (adds, removes, qty), so repeat drawer opens after a cart change show a
       fresh set; in-cart exclusion (below) runs on every render. */
    var rot = window.__ciRecsRot = window.__ciRecsRot || { fp: null, offset: -1 };
    if (rot.fp !== fp) { rot.fp = fp; rot.offset += 1; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var pull = function (intent) {
      return fetch(root + 'recommendations/products.json?product_id=' + encodeURIComponent(lead) + '&limit=10&intent=' + intent, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (json) { return (json.products || []).filter(function (p) { return p && p.handle && p.available !== false; }); });
    };
    /* 2026-09-23, Ondrej: "for whatever reason there is only three upsell
       items now ... never show only three". The complementary list is the
       co-purchase engine's, and a product can have fewer complements than
       the strip has slots (I Am At Peace Amethyst Lamp: exactly 3), while
       `related` was only ever used when complementary was EMPTY. Now the
       complementary window keeps its rotation and its lead position exactly
       as before, and `related` tops the candidates up (deduped, in-cart
       excluded) whenever complements alone cannot fill limit x 2 candidates
       (the x2 is the existing headroom for rows that fail to render). Each
       row carries its own intent, so tracking still says which engine
       supplied it. */
    var poolCache = window.__ciRecsPool;
    var poolPromise = (poolCache && poolCache.key === lead && poolCache.items)
      ? Promise.resolve(poolCache.items)
      : pull('complementary').then(function (items) { window.__ciRecsPool = { key: lead, items: items, intent: items.length ? 'complementary' : 'related' }; return items; });
    var relatedFor = function () {
      var pc = window.__ciRecsPool;
      if (pc && pc.key === lead && pc.related) return Promise.resolve(pc.related);
      return pull('related').then(function (r) { if (pc && pc.key === lead) pc.related = r; return r; });
    };
    return poolPromise.then(function (items) {
      var pool = items.filter(function (p) { return !inCart[p.handle]; });
      var want = limit * 2;
      var candidates = [], ranks = [], intents = [], taken = {};
      if (pool.length) {
        var start = ((rot.offset * limit) % pool.length + pool.length) % pool.length;
        for (var i = 0; i < Math.min(want, pool.length); i++) {
          var cp = pool[(start + i) % pool.length];
          candidates.push(cp); ranks.push((start + i) % pool.length); intents.push('complementary'); taken[cp.handle] = 1;
        }
      }
      var topUp = candidates.length >= want ? Promise.resolve() : relatedFor().then(function (rel) {
        var relPool = rel.filter(function (p) { return !inCart[p.handle] && !taken[p.handle]; });
        if (!relPool.length) return;
        /* no complements at all: related IS the list, so it rotates exactly
           as it did before this change; as a top-up it fills in rank order */
        var rs = candidates.length ? 0 : ((rot.offset * limit) % relPool.length + relPool.length) % relPool.length;
        for (var j = 0; j < relPool.length && candidates.length < want; j++) {
          var rk = (rs + j) % relPool.length;
          candidates.push(relPool[rk]); ranks.push(rk); intents.push('related');
        }
      });
      return topUp.then(function () {
      if (!candidates.length) return false;
      var intent = intents[0] || 'related';
      var section = self.dataset.recSection || 'ci-drawer-rec';
      return Promise.all(candidates.map(function (p, ci) {
        return fetch('/products/' + encodeURIComponent(p.handle) + '?section_id=' + section, { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var li = doc.querySelector('li');
            var add = li && li.querySelector('.ci-rec-add');
            if (!add) return '';
            /* 2026-09-02 tracking: who recommended what, at which rank, from which
               engine. Same fields ride on the add as hidden line properties so the
               order itself says which suggestion sold. */
            li.setAttribute('data-rec-host', String(lead));
            li.setAttribute('data-rec-candidate', String(p.id || ''));
            li.setAttribute('data-rec-rank', String(ranks[ci]));
            li.setAttribute('data-rec-intent', intents[ci]);
            /* 2026-09-07: click-through "product discovery" attribution
               (assets/ci-discovery.js) — data-ci-disc-product already rendered
               by snippets/ci-drawer-rec-row.liquid; rank is only known here. */
            li.setAttribute('data-ci-disc-rank', String(ranks[ci]));
            var props = {};
            try { props = JSON.parse(add.getAttribute('data-properties') || '{}'); } catch (pe) {}
            props._upsell_host = String(lead); props._upsell_rank = String(ranks[ci]); props._upsell_intent = intents[ci];
            add.setAttribute('data-properties', JSON.stringify(props));
            return li.outerHTML;
          })
          .catch(function () { return ''; });
      })).then(function (rows) {
        var valid = rows.filter(Boolean).slice(0, limit);
        if (!valid.length) return false;
        /* 2026-10-12: the drawer re-rendered mid-load and this element is gone: cache the rows anyway, or every later element of this fingerprint attaches to the resolved in-flight promise and gets '' (empty grey box) */
        if (!self.isConnected) { window.__ciRecsCache = { fp: fp, html: valid.join('') }; return true; }
        /* keep the container's discovery-attribution attributes in sync with
           the resolved lead product / intent (mini-cart.liquid can only
           render the static defaults at page load). */
        self.setAttribute('data-ci-disc-host', String(lead));
        self.setAttribute('data-ci-disc-intent', intent);
        self.setList(valid.join(''));
        return true;
      });
      });
    });
  }

  loadShopify(attempt) {
    var self = this;
    fetch(this.dataset.url)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var el = html.querySelector('cart-recommendations');
        var ul = el && el.querySelector('.mini-cart__navigation');
        if (ul && ul.innerHTML.trim().length) {
          self.setList(ul.innerHTML);
        } else if (attempt < 2) {
          setTimeout(function () { self.loadShopify(attempt + 1); }, 4000);
        }
      })
      .catch(function (e) {
        console.error(e);
        if (attempt < 2) setTimeout(function () { self.loadShopify(attempt + 1); }, 4000);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
})();
